<div class="page-header-weekly">
    <button mat-button class="nav-button" (click)="navBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="title" style="padding-left: 100px;">
        YTD RESULTS BY BRANCH FOR WEEK no. {{ requestData.weekNo }} ENDING {{
      getWeekEndingDate(requestData.year, requestData.weekNo) }}
    </div>
    <div class="action-btn-container">
      <button mat-button color="accent" class="action-btn export-btn" (click)="exportClicked()"
        [disabled]="IsDownloading">
        <img class="download-icon"
          [src]="IsDownloading ? 'assets/images/animated/download/download-anim.svg' : 'assets/images/animated/download/download-no-anim.svg'">
        Export
      </button>
    </div>
</div>

<div class="report-container">
  <div *ngIf="reportData && reportData.length > 0; else noData" class="table-container">
    <table mat-table [dataSource]="reportData" matSort>

      <!-- Group Header Columns -->
      <ng-container matColumnDef="shopGroup" sticky>
        <th mat-header-cell *matHeaderCellDef colspan="1" class="grouped-header"></th>
      </ng-container>
      <ng-container matColumnDef="salesGroup">
        <th mat-header-cell *matHeaderCellDef colspan="4" class="grouped-header">Sales</th>
      </ng-container>

      <ng-container matColumnDef="ordersGroup">
        <th mat-header-cell *matHeaderCellDef colspan="6" class="grouped-header">Number of Orders</th>
      </ng-container>

      <ng-container matColumnDef="labourGroup">
        <th mat-header-cell *matHeaderCellDef colspan="3" class="grouped-header">Labour Cost %</th>
      </ng-container>

      <!-- Data Columns -->
      <ng-container matColumnDef="shop_name" sticky>
        <th mat-header-cell *matHeaderCellDef class="th-bordered">Store</th>
        <td mat-cell *matCellDef="let item">{{item.shop_name}}</td>
        <td mat-footer-cell *matFooterCellDef><strong>Total</strong></td>
      </ng-container>

      <!-- ✅ UPDATED: YTD Sales This Year -->
      <ng-container matColumnDef="this_year_this_week_sales">
        <th mat-header-cell *matHeaderCellDef class="header">This Year</th>
        <td mat-cell *matCellDef="let item" class="amount">${{item.ytd_sales ?? 0 | number:'1.0-0'}}</td>
        <td mat-footer-cell *matFooterCellDef class="bold-footer">${{totalDetails.total_ytd_sales | number:'1.0-0'}}</td>
      </ng-container>

      <!-- ✅ UPDATED: YTD Sales Last Year -->
      <ng-container matColumnDef="last_year_this_week_sales">
        <th mat-header-cell *matHeaderCellDef class="header">Last Year</th>
        <td mat-cell *matCellDef="let item" class="amount">${{item.last_year_ytd_sales ?? 0 | number:'1.0-0'}}</td>
        <td mat-footer-cell *matFooterCellDef class="bold-footer">${{totalDetails.total_ly_sales | number:'1.0-0'}}</td>
      </ng-container>

      <!-- ✅ UPDATED: Sales Variance -->
      <ng-container matColumnDef="sales_var">
        <th mat-header-cell *matHeaderCellDef class="header">Var ($)</th>
        <td mat-cell *matCellDef="let item" class="amount">${{(item.ytd_sales - item.last_year_ytd_sales) | number:'1.0-0'}}</td>
        <td mat-footer-cell *matFooterCellDef class="bold-footer">${{totalDetails.sales_variance | number:'1.0-0'}}</td>
      </ng-container>

      <!-- ✅ UPDATED: Sales Variance Percentage -->
      <ng-container matColumnDef="sales_var_percent">
        <th mat-header-cell *matHeaderCellDef class="th-bordered header">Var (%)</th>
        <td mat-cell *matCellDef="let item" class="amount">
          {{
            ((item.last_year_ytd_sales ?? 0) === 0
              ? 0
              : ((item.ytd_sales - (item.last_year_ytd_sales)) 
                 / (item.last_year_ytd_sales)) * 100
            ) | number:'1.2-2'
          }}%
        </td>
        <td mat-footer-cell *matFooterCellDef class="bold-footer">
          {{totalDetails.sales_growth | number:'1.2-2'}}%
        </td>
      </ng-container>

      <!-- ✅ UPDATED: Customer Orders This Year -->
      <ng-container matColumnDef="this_week_cust_orders">
        <th mat-header-cell *matHeaderCellDef class="header">This Year</th>
        <td mat-cell *matCellDef="let item" class="amount">{{item.ytd_no_of_cust_orders | number:'1.0-0'}}</td>
        <td mat-footer-cell *matFooterCellDef class="bold-footer">{{totalDetails.total_cust_order_ty | number:'1.0-0'}}</td>
      </ng-container>

      <!-- ✅ UPDATED: Customer Orders Last Year -->
      <ng-container matColumnDef="last_year_cust_orders">
        <th mat-header-cell *matHeaderCellDef class="header">Last Year</th>
        <td mat-cell *matCellDef="let item" class="amount">{{item.last_year_cus_order | number:'1.0-0'}}</td>
        <td mat-footer-cell *matFooterCellDef class="bold-footer">{{totalDetails.total_cust_order_ly | number:'1.0-0'}}</td>
      </ng-container>

      <!-- ✅ UPDATED: Orders Variance -->
      <ng-container matColumnDef="orders_var">
        <th mat-header-cell *matHeaderCellDef class="header">Var</th>
        <td mat-cell *matCellDef="let item" class="amount">{{(item.ytd_no_of_cust_orders - item.last_year_cus_order) | number:'1.0-0'}}</td>
        <td mat-footer-cell *matFooterCellDef class="bold-footer">{{totalDetails.cust_order_variance | number:'1.0-0'}}</td>
      </ng-container>

      <!-- ✅ UPDATED: Orders Variance Percentage -->
      <ng-container matColumnDef="orders_var_percent">
        <th mat-header-cell *matHeaderCellDef class="header">Var (%)</th>
        <td mat-cell *matCellDef="let item" class="amount">
          {{(item.last_year_cus_order === 0 ? 0 :
          ((item.ytd_no_of_cust_orders - item.last_year_cus_order) / item.last_year_cus_order) * 100
          ) | number:'1.2-2'}}%
        </td>
        <td mat-footer-cell *matFooterCellDef class="bold-footer">
          {{totalDetails.cust_order_growth | number:'1.2-2'}}%
        </td>
      </ng-container>

      <!-- ✅ UPDATED: Average Sale This Year -->
      <ng-container matColumnDef="avg_sale_ty">
        <th mat-header-cell *matHeaderCellDef class="header">Avg Sale (TY)</th>
        <td mat-cell *matCellDef="let item" class="amount">
          {{(item.ytd_no_of_cust_orders === 0 ? 0 : item.ytd_sales / item.ytd_no_of_cust_orders) | number:'1.2-2'}}
        </td>
        <td mat-footer-cell *matFooterCellDef class="bold-footer">{{totalDetails.avg_sales_per_order_ty | number:'1.2-2'}}</td>
      </ng-container>

      <!-- ✅ UPDATED: Average Sale Last Year -->
      <ng-container matColumnDef="avg_sale_ly">
        <th mat-header-cell *matHeaderCellDef class="th-bordered header">Avg Sale (LY)</th>
        <td mat-cell *matCellDef="let item" class="amount">
          {{(item.last_year_cus_order === 0 ? 0 : item.last_year_ytd_sales / item.last_year_cus_order) | number:'1.2-2'}}
        </td>
        <td mat-footer-cell *matFooterCellDef class="bold-footer">{{totalDetails.avg_sales_per_order_ly | number:'1.2-2'}}</td>
      </ng-container>

      <!-- ✅ CORRECTED: Labour Cost This Year -->
      <ng-container matColumnDef="labour_percent_ty">
        <th mat-header-cell *matHeaderCellDef class="header">This Year</th>
        <td mat-cell *matCellDef="let item" class="amount">{{item.ytd_labour_per ?? 0 | number:'1.2-2'}}%</td>
        <td mat-footer-cell *matFooterCellDef class="bold-footer">
          {{totalDetails.total_labour_cost_ty | number:'1.2-2'}}%
        </td>
      </ng-container>

      <!-- ✅ CORRECTED: Labour Cost Last Year -->
      <ng-container matColumnDef="labour_percent_ly">
        <th mat-header-cell *matHeaderCellDef class="header">Last Year</th>
        <td mat-cell *matCellDef="let item" class="amount">{{item.last_year_labour_per ?? 0 | number:'1.2-2'}}%</td>
        <td mat-footer-cell *matFooterCellDef class="bold-footer">
          {{totalDetails.total_labour_cost_ly | number:'1.2-2'}}%
        </td>
      </ng-container>

      <!-- ✅ CORRECTED: Labour Cost Variance (uses API calculated value) -->
      <ng-container matColumnDef="labour_percent_var">
        <th mat-header-cell *matHeaderCellDef class="header">Var %</th>
        <td mat-cell *matCellDef="let item" class="amount">
          {{((item.ytd_labour_per ?? 0) - (item.last_year_labour_per ?? 0)) | number:'1.2-2'}}%
        </td>
        <td mat-footer-cell *matFooterCellDef class="bold-footer">
          {{totalDetails.labour_cost_growth | number:'1.2-2'}}%
        </td>
      </ng-container>

      <!-- Table Structure -->
      <tr mat-header-row *matHeaderRowDef="groupHeaderColumns; sticky: true"></tr>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true" class="total-row"></tr>

    </table>
  </div>

  <ng-template #noData>
    <div class="no-data-message" *ngIf="!isLoading">
      No Data Found.
    </div>
    <div *ngIf="isLoading" class="loading-message">
      Please wait, loading data...
    </div>
  </ng-template>
</div>